import React from 'react';
import { searchUrl } from '@/constants/urls';
import CardItem from '@/components/cards/CardItem';
import NameDescriptionCard from '@/components/cards/NameDescriptionCard';
import SearchTools from '../containers/SearchTools';

const SearchCardItem = ({
  category,
  onCheckBoxClick,
  search,
  single,
  upward,
}) => (
  <CardItem className="aridhia-search-list-item">
    <NameDescriptionCard
      description={search.description}
      entity="search"
      link={searchUrl(search)}
      markdown
      name={search.name}
      onSelect={onCheckBoxClick ? () => onCheckBoxClick(category, search.code) : undefined}
      selected={search.selected}
      single={single}
      visibility={search.visibility}
    >
      <SearchTools
        category={category}
        iconSize="large"
        listItem
        search={search}
        upward={upward}
        url={searchUrl(search, '#')}
      />
    </NameDescriptionCard>
  </CardItem>
);

export default SearchCardItem;
